<template>
    <div>
        <div class="ListMenuBox">
            <div class="MenuList">
               <span v-for="(v,i) in 3 " :class="i==CurrInt?'act':''" :key="i" @click="LookNavList(i)">公安机关人民警察执法资格考试系统</span>
            </div>
            <div class="ListArrBox"  v-for="(v,i) in 15 " :class="i==0?'act':''" :key="i" @click="LookInfo()">
              <div class="ArrTitle">
                <div>市局圆满完成2019年公安机关高级执法资格考试市局圆满完成2019年公安机关高级执法资格考试</div>
                <span>2020-10-13</span>
              </div>
              <div class="ArrTxt">
                  2019年公安机关高级执法资格考试（松原地区考场）于11月10日在松原市第五中学举行，松原、白城两地共计210名民警在松原考场参加此次考试。公安部、省厅巡考组一行在市局副局长张毅和法制支队负责同志陪同下，对考试全程进行了监督巡查，并对我局考试组织工作和考场纪律给予高度肯定……
              </div>
            </div>
            <el-pagination
                style="margin-top:50px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage1"
                :page-size="15"
                layout="total, prev, pager, next"
                :total="50">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    data() {
      return {
        currentPage1: 5,
        MenuAct:'',
        CurrInt:'',
        NavIndex:'',
      }
    },
    methods:{  
      GetNavClick(e){
        this.NavIndex = e;
      }, 
      LookInfo(){
        this.$router.push('/ListArtInfo?id=1')
      },
      LookNavList(n){
        this.CurrInt = n;
      },
      ChangeNavMenu(n){
        this.MenuAct= n;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    }
}
</script>
<style lang="scss" scoped>
  .ListMenuBox{
      width:1260px;
      margin: 60px auto 0;
      .MenuList{
        display: inline-flex;
        width:100%;
        margin-bottom: 60px;
        span{
          background:  #F5F5F5;;
          width:calc(100% / 3);
          padding: 5px 20px;
          // line-height: 30px;
          font-size: 15px;
          &:hover{
            cursor: pointer;
            //  color:#fff;
             transform: scale(1.03);
            // background: linear-gradient(90deg, #4160CE, #4160CE);
            transition: all .5s;
          }
        }
        span:nth-child(2){
          margin: 0 20px;
        }
        .act{
          color:#fff;
          background: linear-gradient(90deg, #4160CE, #4160CE);
        }
      }
      .ListArrBox{
        width:100%;
        padding: 20px 0;
        border-bottom: 1px solid rgba(238, 238, 238, .7);
        &:hover > .ArrTitle>div{
           color:rgba(65, 96, 206, 1);
           cursor: pointer;
        }
        .ArrTitle{
          display: inline-flex;
          width:100%;
          color: #333333;
          div{
            flex:1;
            font-size: 16px;
            font-weight: 400;
            text-align: left;
            &::before{
              content: '⦁';
              font-size: 16px;
              padding-right:5px ;
            }
          }
          span{
            width:150px;
            text-align: right;
          }
        }
        .ArrTxt{
          margin-top:10px ;
          text-align: left;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
  }
</style>